import "./App.css";
import Container from "./Container.js";
import Bottom from "./Bottom.js";

function App() {
  return (
    <div className="App">
      <Container />
      <Bottom />
    </div>
  );
}

export default App;
